<template>
    <div>
        <vs-row>
            <vs-col sm="12" lg="6">
                <h4>Gestión de usuarios</h4>
            </vs-col>
            <vs-col sm="12" lg="6">
                <vs-button
                    success
                    class="ml-auto"
                    @click="activeCrear =! activeCrear"
                >
                    <i class="fas fa-plus mr-2"></i> Crear usuario
                </vs-button>
            </vs-col>
        </vs-row>
        <vs-row class="mt-3">
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Institución <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length" autocomplete="off">
                        <template #message-danger v-if="errorFields.includes('institucion')">
                            Requerido
                        </template>
                        <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Rol <i class="fas fa-shield-alt"></i>
                    </label>
                    <vs-select filter :loading="loadingRol" class="aqui pt-0" id="institucion" placeholder="Seleccionar el rol" :key="rolId" v-model="rol" :disabled="!roles[0]">
                        <template #message-danger v-if="errorFields.includes('rol')">
                            Requerido
                        </template>
                        <vs-option v-for="option in roles" :key="option.id"  :label="option.text" :value="option.id">
                            {{option.text}}
                        </vs-option>
                    </vs-select>
                </form>
            </vs-col>
            <vs-col sm="12" lg="3">
                <form autocomplete="off">
                    <label for="institucion" class="labelInput">
                        Nombres
                    </label>
                    <vs-input class="pt-0" v-model="nombres" placeholder="Nombres" />
                </form>
            </vs-col>
            <vs-col sm="12" lg="3" style="margin-top: 23px; display: flex">
                <vs-button
                    @click="getGestionUsuarios()"
                >
                    <i class="fas fa-search mr-2"></i>Buscar
                </vs-button>
            </vs-col>
        </vs-row>
        <crear-rol v-model="activeCrear" :instituciones="instituciones" :institucionId="institucionId" @refreshTable="getInfo"></crear-rol>
        <gestion-roles class="mt-4" :users="users" :instituciones="instituciones" :institucionId="institucionId" @refreshTable="getGestionUsuarios" :page="page" :pages="pages" @getPage="getGestionUsuarios"></gestion-roles>
    </div>
</template>
<script>
import accesibilidad from '../../../../api/requests/accesibilidad'
import CrearRol from './modal/crear.vue'
import GestionRoles from './tabla-gestion-usuarios.vue'
export default {
    data:() =>({
        activeCrear: false,
        institucion:'',
        instituciones: [],
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        rol: '',
        roles: [],
        rolId: (new Date()).getTime(),
        loadingRol: false,
        nombres: '',
        nombre_usuario: '',
        errorFields: [],
        users: [],
        page: 1, 
        max: 10,
        pages: 0, 
    }),
    components:{
       CrearRol,
       GestionRoles
    },
    created(){
        this.getInstituciones()
    },
    methods: {
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await accesibilidad.getInstitucionGestionUsuario()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }
            catch{

            }
        },  
        async getRol(){
            try {
                this.loadingRol = true
                const response = await accesibilidad.getRol(this.institucion)
                this.roles = response.data
                this.rolId = (new Date()).getTime()
                this.loadingRol = false
            }
            catch{

            }
        },
        async getGestionUsuarios(pagina){
                this.page = pagina ? pagina : 1
                const loading = this.$vs.loading()
                try{
                    const params = {
                        page: this.page || 1,
                        institucion_id: this.institucion,
                        role_id: this.rol,
                        name:this.nombres ,
                        username:this.nombre_usuario ,
                    }
                    const {data: response} = await accesibilidad.getGestionUsuarios(params)
                    loading.close()
                    
                    const { data: dataTable = [], per_page = 20, total = 0 } = response || {}
                    this.pages = Math.ceil(total/per_page) || 0
                    this.users = dataTable
                }
                catch(error){
                    console.error(error)
                    loading.close()
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Se produjo un error',
                        text: 'Favor de contactar al adminsitrador'
                    })
                }
        },
        getInfo(institucion, rol){
            this.institucion = institucion
            this.rol = rol
            this.getGestionUsuarios()
        },
    },
    watch:{
        institucion(){
            this.getRol()
        },
        rol(){
            this.getGestionUsuarios()
        }
    }
    
}
</script>